import { render, staticRenderFns } from "./recommendRender.vue?vue&type=template&id=1b2d70d2&scoped=true"
import script from "./recommendRender.vue?vue&type=script&lang=js"
export * from "./recommendRender.vue?vue&type=script&lang=js"
import style0 from "./recommendRender.vue?vue&type=style&index=0&id=1b2d70d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d70d2",
  null
  
)

export default component.exports